export default __webpack_public_path__ + "static/media/edit-btn.bc3bf1f3.svg";